import * as service from "../service";
import type { ServiceResponse } from "../types";

export type BusinessReviewStatus = "pending" | "approved" | "rejected";

export type BusinessReviewRow = Record<string, any>;

/**
 * Business registrations waiting for an admin decision (admin only).
 * Backend: GET /api/business/reviews?status=pending|approved|rejected
 */
export const GetBusinessReviewsAPI = async (
  status: BusinessReviewStatus = "pending",
): Promise<ServiceResponse<BusinessReviewRow[]>> => {
  try {
    const resp = (await service.call("GET", "/api/business/reviews", {
      status,
    })) as ServiceResponse<BusinessReviewRow[]>;
    if (!resp) return { status: 2 };
    return resp;
  } catch (err) {
    console.error(`GetBusinessReviewsAPI ${err}`);
    return { status: -1, error: err };
  }
};

/**
 * Approve a pending business registration (admin only).
 * Backend: POST /api/business/reviews/approve { user_id }
 */
export const ApproveBusinessAPI = async (
  user_id: string,
): Promise<ServiceResponse<Record<string, any>>> => {
  try {
    const resp = (await service.call("POST", "/api/business/reviews/approve", {
      user_id,
    })) as ServiceResponse<Record<string, any>>;
    if (!resp) return { status: 2 };
    return resp;
  } catch (err) {
    console.error(`ApproveBusinessAPI ${err}`);
    return { status: -1, error: err };
  }
};

/**
 * Reject a pending business registration, keeping the row (admin only).
 * Backend: POST /api/business/reviews/reject { user_id }
 */
export const RejectBusinessAPI = async (
  user_id: string,
): Promise<ServiceResponse<Record<string, any>>> => {
  try {
    const resp = (await service.call("POST", "/api/business/reviews/reject", {
      user_id,
    })) as ServiceResponse<Record<string, any>>;
    if (!resp) return { status: 2 };
    return resp;
  } catch (err) {
    console.error(`RejectBusinessAPI ${err}`);
    return { status: -1, error: err };
  }
};
